import type { ReactNode } from 'react';
import { Box, Grid, Typography } from '@mui/material';

export interface DetailFieldProps {
  label: ReactNode;
  value: ReactNode;
  /** Falsy değerde gösterilecek yer tutucu. */
  placeholder?: string;
  /** 12 sütunluk gridde kapladığı genişlik (md+). Varsayılan 4 → 3'lü sıra. */
  span?: 1 | 2 | 3 | 4 | 6 | 12;
  multiline?: boolean;
  monospace?: boolean;
}

function isEmpty(value: ReactNode): boolean {
  return value == null || value === '' || value === false;
}

/** Etiket + değer çifti — bugüne kadar her detay sayfasında elle yazılan
 *  `<Typography caption> + <Typography body2> + '—'` kalıbının tek yeri.
 *  `<DetailSection>` içindeki `<Grid container>`'a bir `<Grid item>` olarak girer. */
export function DetailField({
  label,
  value,
  placeholder = '—',
  span = 4,
  multiline = false,
  monospace = false,
}: DetailFieldProps) {
  return (
    <Grid size={{ xs: 12, sm: 6, md: span }}>
      <Typography variant="caption" color="text.secondary" component="div">
        {label}
      </Typography>
      <Box
        sx={{
          typography: 'body2',
          fontWeight: 500,
          whiteSpace: multiline ? 'pre-wrap' : 'normal',
          fontFamily: monospace ? 'ui-monospace, SFMono-Regular, Menlo, monospace' : undefined,
          wordBreak: 'break-word',
        }}
      >
        {isEmpty(value) ? (
          <Box component="span" sx={{ color: 'text.disabled' }}>
            {placeholder}
          </Box>
        ) : (
          value
        )}
      </Box>
    </Grid>
  );
}
